var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRadioSelectedi = function SvgRadioSelectedi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color || 'currentColor'
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3c-4.967 0-9 4.033-9 9s4.033 9 9 9 9-4.033 9-9-4.033-9-9-9m0 1.4c4.195 0 7.6 3.405 7.6 7.6s-3.405 7.6-7.6 7.6-7.6-3.405-7.6-7.6S7.805 4.4 12 4.4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRadioSelectedi);
export default ForwardRef;